var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            fill: _vm.color,
            "fill-rule": "evenodd",
            transform: "translate(0 -1)",
          },
        },
        [
          _c("rect", {
            attrs: {
              width: "25",
              height: "2.5",
              x: "-2.5",
              y: "9.375",
              rx: ".3",
              transform: "rotate(45 10 10.625)",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              width: "25",
              height: "2.5",
              x: "-2.5",
              y: "9.375",
              rx: ".3",
              transform: "rotate(-45 10 10.625)",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }